import { useState, useEffect } from 'react';
import { Download } from 'lucide-react';

// "Uygulamayı Yükle" — tarayıcı kurulabilir olduğunda (beforeinstallprompt)
// görünür; tıklayınca kurulum penceresini açar. Zaten kuruluysa gizlenir.
export function InstallAppButton({ className = '' }: { className?: string }) {
  const [promptEvent, setPromptEvent] = useState<any>(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    // Zaten standalone (kurulu) çalışıyorsa buton gösterme
    const standalone = window.matchMedia?.('(display-mode: standalone)').matches
      || (window.navigator as any).standalone === true;
    if (standalone) { setInstalled(true); return; }

    const onPrompt = (e: any) => { e.preventDefault(); setPromptEvent(e); };
    const onInstalled = () => { setInstalled(true); setPromptEvent(null); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (installed || !promptEvent) return null;

  const install = async () => {
    try {
      promptEvent.prompt();
      await promptEvent.userChoice;
    } catch { /* kullanıcı vazgeçtiyse yoksay */ }
    setPromptEvent(null);
  };

  return (
    <button
      type="button"
      onClick={install}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-medium ${className}`}
      title="Cleandy'yi masaüstüne/uygulama olarak yükle"
    >
      <Download className="w-4 h-4" />
      Uygulamayı Yükle
    </button>
  );
}
